import { render } from "./InventoryTransfer.vue?vue&type=template&id=5f5811f2"
import script from "./InventoryTransfer.vue?vue&type=script&lang=js"
export * from "./InventoryTransfer.vue?vue&type=script&lang=js"
script.render = render

export default script